/** CoStar.Api.SuiteDetail.TenantCompanyLandlordCompanies.SortType */
export var SortType;
(function (SortType) {
    SortType[SortType["None"] = 0] = "None";
    SortType[SortType["CompanyAsc"] = 1] = "CompanyAsc";
    SortType[SortType["CompanyDesc"] = 2] = "CompanyDesc";
    SortType[SortType["TenantLocationsAsc"] = 3] = "TenantLocationsAsc";
    SortType[SortType["TenantLocationsDesc"] = 4] = "TenantLocationsDesc";
    SortType[SortType["TenantSfOccupiedAsc"] = 5] = "TenantSfOccupiedAsc";
    SortType[SortType["TenantSfOccupiedDesc"] = 6] = "TenantSfOccupiedDesc";
    SortType[SortType["TypeAsc"] = 7] = "TypeAsc";
    SortType[SortType["TypeDesc"] = 8] = "TypeDesc";
    SortType[SortType["SecondaryTypeAsc"] = 9] = "SecondaryTypeAsc";
    SortType[SortType["SecondaryTypeDesc"] = 10] = "SecondaryTypeDesc";
    SortType[SortType["HqCityAsc"] = 11] = "HqCityAsc";
    SortType[SortType["HqCityDesc"] = 12] = "HqCityDesc";
    SortType[SortType["HqStateAsc"] = 13] = "HqStateAsc";
    SortType[SortType["HqStateDesc"] = 14] = "HqStateDesc";
    SortType[SortType["HqCountryAsc"] = 15] = "HqCountryAsc";
    SortType[SortType["HqCountryDesc"] = 16] = "HqCountryDesc";
})(SortType || (SortType = {}));
